import { AfterViewInit, Component, OnDestroy, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './features/auth/services/auth.service';
import { filter, Subject, takeUntil } from 'rxjs';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  standalone: false,
  styleUrl: './app.scss'
})
export class App implements  OnInit, OnDestroy, AfterViewInit {
  protected readonly title = signal('Frontend-DRS-USA');

  msg: string = '';
  avail: boolean = false;

    loginStatus: boolean = false;
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private readonly auth: AuthService,
    private readonly router: Router,
    private readonly broadcastService: MsalBroadcastService,
    private readonly msalService: MsalService,
  ) {}

  ngOnInit(): void {

        this.checkLoginStatus();

    this.broadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.ACCOUNT_ADDED || msg.eventType === EventType.ACCOUNT_REMOVED),
      )
      .subscribe(() => {
        this.checkLoginStatus();
      });

    this.broadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.checkLoginStatus();
      });

  }

    checkLoginStatus() {
    this.loginStatus = this.msalService.instance.getAllAccounts().length > 0;

    if (this.loginStatus) {
      const account = this.msalService.instance.getAllAccounts()[0];
      this.msalService.instance.setActiveAccount(account);
      this.auth.isLogged();
    }
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  ngAfterViewInit() {
    const clientId =
      "446449612474-l2qr6hjh3fpuoom376m3f0iarj5vjgsf.apps.googleusercontent.com";

    const tryInit = () => {
      const win: any = window as any;
      if (win.google?.accounts?.id) {
        try {
          win.google.accounts.id.initialize({
            client_id: clientId,
            callback: (response: any) => {
              if (typeof (window as any).handleCredentialResponse === "function") {
                (window as any).handleCredentialResponse(response);
              }
            },
          });

          const btn = document.querySelector(".g_id_signin");
          if (btn && win.google?.accounts?.id?.renderButton) {
            win.google.accounts.id.renderButton(btn, {
              type: "standard",
              shape: "pill",
              theme: "filled_blue",
              text: "signin_with",
              size: "large",
              logo_alignment: "left",
            });
          }

          return true;
        } catch (e) {
          console.warn("Google Identity init error:", e);
        }
      }
      return false;
    };

    if (!tryInit()) {
      const interval = setInterval(() => {
        if (tryInit()) {
          clearInterval(interval);
        }
      }, 200);
    }
  }
}
